import PropTypes from "prop-types";
import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{this.props.pageTitle} </title>
                    <link rel="canonical" href="https://solutoz.com" />
                    <meta name="robots" content="follow" />
                    <meta name="description" content="Solutoz – Focused to deliver Simplified & Easy to Use Solutions through a Holistic Digital Experience for businesses growth & optimization." />
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                </Helmet>
            </React.Fragment>
        )
    }
}
PageHelmet.propTypes = {
    title: PropTypes.string
};
export default PageHelmet;
